var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96094 11.0001L0.210938 6.25008L1.39844 5.06258L4.96094 8.62508L12.6068 0.979248L13.7943 2.16675L4.96094 11.0001Z",
    fill: "#25B918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveicon);
export default __webpack_public_path__ + "static/media/approveicon.a30470a56d29c3be28f1bb0cda52ee4b.svg";
export { ForwardRef as ReactComponent };